// eslint-disable-next-line implicit-dependencies/no-implicit
import type whyDidYouRenderType from "@welldone-software/why-did-you-render";
import React from "react";

if (process.env.NODE_ENV === "development") {
    if (typeof window !== "undefined") {
        // eslint-disable-next-line @typescript-eslint/no-var-requires, implicit-dependencies/no-implicit
        const whyDidYouRender = require("@welldone-software/why-did-you-render") as typeof whyDidYouRenderType;
        whyDidYouRender(React);
    }
}
